//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axios, { CancelToken } from "axios";

export default {
  // props: {
  //   loc: String,
  //   dept: String
  // },
  data() {
    return {
      loc: "G1",
      pic1: null,
      pic2: null,
      pic3: null,
      pic4: null
    };
  },

  computed: {
    dept1() {
      return `data:image/png;base64, ${this.pic1}`;
    },
    dept2() {
      return `data:image/png;base64, ${this.pic2}`;
    },
    dept3() {
      return `data:image/png;base64, ${this.pic3}`;
    },
    dept4() {
      return `data:image/png;base64, ${this.pic4}`;
    }
  },
  async mounted() {
    // let a = await this.defaultPeriod();
    // this.refreshComponent = true;
    let _pic1 = await this.loadpic1();
    let _pic2 = await this.loadpic2();
    let _pic3 = await this.loadpic3();
    // this.loadpic4();
  },
  methods: {
    loadpic1() {
      let params = new FormData();

      params.append("loc", this.loc);
      params.append("dept", "SEW-01");
      params.append("ps", "");
      params.append("pe", "");

      const obj = axios({
        method: "post",
        url: "http://127.0.0.1:5000/boardeffchart",
        data: params
      }).then(res => {
        // console.log(res.data)
        this.pic1 = res.data;
      });

      return obj;
    },
    loadpic2() {
      let params = new FormData();

      params.append("loc", this.loc);
      params.append("dept", "SEW-02");
      params.append("ps", "");
      params.append("pe", "");

      const obj = axios({
        method: "post",
        url: "http://127.0.0.1:5000/boardeffchart",
        data: params
      }).then(res => {
        // console.log(res.data)
        this.pic2 = res.data;
      });

      return obj;
    },
    loadpic3() {
      let params = new FormData();

      params.append("loc", this.loc);
      params.append("dept", "SEW-03");
      params.append("ps", "");
      params.append("pe", "");

      const obj = axios({
        method: "post",
        url: "http://127.0.0.1:5000/boardeffchart",
        data: params
      }).then(res => {
        // console.log(res.data)
        this.pic3 = res.data;
      });

      return obj;
    },
    loadpic4() {
      let params = new FormData();

      params.append("loc", this.loc);
      params.append("dept", "SEW-04");
      params.append("ps", "");
      params.append("pe", "");

      const obj = axios({
        method: "post",
        url: "http://127.0.0.1:5000/boardeffchart",
        data: params
      }).then(res => {
        // console.log(res.data)
        this.pic4 = res.data;
      });

      return obj;
    }
  }
};
